import React from 'react';
export interface CardProps {
  children: React.ReactNode;
  className?: string;
}
export function Card({
  children,
  className = ''
}: CardProps) {
  return <div className={`bg-white border border-slate-100 rounded-2xl shadow-[0_1px_3px_rgba(0,0,0,0.04)] ${className}`} data-id="element-331">
      {children}
    </div>;
}